import { useRef } from 'react';

import { IoMdClose } from "react-icons/io";
import { t } from 'i18next';
import Steper from './Steper/Steper';
import styles from './ManageJob.module.css';
import EditJob from './Forms/EditJob';
import { useNavigate } from 'react-router-dom';

function PostJob({ activeSteps, activeTab, id, setActiveSteps, setPostJobEnable }) {
    const navigate = useNavigate();
    const editJobRef = useRef(null);

    const handleStepValidation = (currentStep, targetStep) => {
        // Call the validate function from EditJob component
        if (editJobRef.current && editJobRef.current.validateStep) {
            return editJobRef.current.validateStep(currentStep, targetStep);
        } else {
            return true;
        }
    };

    const handleStepChange = (step) => {
        // If we have the jump function in EditJob, use it
        if (editJobRef.current && editJobRef.current.jumpToStep) {
            editJobRef.current.jumpToStep(step);
        } else {
            // Fallback to direct step change
            setActiveSteps(step);
        }
    };

    return (
        <>
            <div className={styles.editContainer}>
                {activeTab == 0 &&
                    <>
                        <IoMdClose onClick={() => {
                            navigate(`/employer-portal`);
                            setPostJobEnable(false)
                        }} className={styles.crossIcon} />
                        <p className={styles.heading}>{t(id ? "forms.manage_job.title_edit" : 'Post_a_new_job')}</p>
                        <Steper
                            activeStep={activeSteps}
                            setActiveSteps={handleStepChange}
                            validateStep={handleStepValidation}
                        />
                        <EditJob
                            ref={editJobRef}
                            activeSteps={activeSteps}
                            setActiveSteps={setActiveSteps}
                            setPostJobEnable={setPostJobEnable} />
                    </>
                }
            </div>
        </>
    );
}

export default PostJob;